module.exports = __webpack_public_path__ + "media/images/flags/CR-1de4535f3b1434c7cf1ddd77d5db7f13.svg";